import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertFromHTML } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import descriptionJobProfileType from "../types/descriptionJobProfileType";
import errorsType from "../types/errorsType";
import {
  SectionTitle,
  EditorWrapper,
  Label,
  LabelText,
  Required,
  Error,
} from "../styles/edit-form-styles";

class DescriptionAndBenefits extends Component {
  constructor(props) {
    super(props);
    this.editor = React.createRef();
    const { jobProfile } = this.props;
    const { description } = jobProfile;

    this.state = {
      editorState: EditorState.createWithContent(
        ContentState.createFromBlockArray(convertFromHTML(description))
      ),
    };
  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  render() {
    const { editorState } = this.state;
    const { inputOnChange, errors } = this.props;

    return (
      <Fragment>
        <SectionTitle>Description</SectionTitle>
        <Label>
          <LabelText>
            Description <Required>*</Required>
          </LabelText>
        </Label>
        <EditorWrapper>
          <Editor
            ref={this.editor}
            toolbarClassName="editor-toolbar"
            editorClassName="editor"
            editorState={editorState}
            onEditorStateChange={this.onEditorStateChange}
            onChange={() => inputOnChange(editorState)}
            toolbar={{
              options: ["inline", "list"],
              inline: {
                options: ["bold", "italic", "underline", "strikethrough"],
              },
              list: {
                options: ["unordered", "ordered"],
              },
            }}
          />
          {errors.description && (
            <Error>{`Job description ${errors.description}.`}</Error>
          )}
        </EditorWrapper>
      </Fragment>
    );
  }
}

DescriptionAndBenefits.propTypes = {
  jobProfile: descriptionJobProfileType.isRequired,
  inputOnChange: PropTypes.func.isRequired,
  errors: errorsType.isRequired,
};

export default DescriptionAndBenefits;
